/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Show_Event_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Show selected event" |
*
* @param {Timing_Sync_Show_Event_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_show_event_aria_label = /** @type {((inputs?: Timing_Sync_Show_Event_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Show_Event_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher l'evenement selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewähltes Ereignis anzeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra l'evento selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Показать выбранное событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar evento seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示所选活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントを表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटना दिखाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exibir evento selecionado")
	return /** @type {LocalizedString} */ ("Show selected event")
});